export const colWidths = [
    5,
    15,//checkbox
    30,
    145,//Client type
    83,//number
    100,//first name
    112,//middle name
    140,// last name
    65,//suffix
    90,//email
    125,//phone number
    95,//location
    145,//group name-group number
    130,//primary task type
    130,//fiscal end year
    80,//status
    60,//staff
    100, //integration
    5,
    50
  ];
  